import React from 'react';

import { CalendarComponent } from './Calendar.js';
import { clickDay, hoverDay, prevMonth, nextMonth } from '../actions.js';

import { connect } from 'react-redux';


const ReduxCalendar = function(props, context) {
    let { state, count, sendHover } = props;
    let { onClick, hoverDay, nextMonth, prevMonth } = props;

    count = count || 1;
    sendHover = typeof sendHover === "undefined" || sendHover;


    let onHover = function(day) {
        if ( sendHover && state.selecting ) {
            hoverDay(day);
        }
    };

    return (
        <div className="multi-calendar">
            { _.times(count, (i) => (
                <CalendarComponent
                    {...state}
                    onClick={onClick}
                    onHover={onHover}
                    offset={i} key={i}
                    nextMonth={(count === 1 || i > 0 ) ? nextMonth : null}
                    prevMonth={(count === 1 || i != count-1) ? prevMonth : null}
                />
            )) }
        </div>
    );
};


const mapStateToProps = (state) => ({
    state: state.calendar,
})

const mapDispatchToProps = (dispatch) => ({
    onClick: day => dispatch(clickDay(day.date)),
    hoverDay: day => dispatch(hoverDay(day.date)),
    prevMonth: _ => dispatch(prevMonth()),
    nextMonth: _ => dispatch(nextMonth()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReduxCalendar);



/** WEBPACK FOOTER **
 ** ../ibe/components/ReduxCalendar.js
 **/